import React from 'react';
import { NavLink } from 'react-router-dom';
import { Shelf, Text } from '@chaser/components';
import useRemoteConfig from '../../../hooks/useRemoteConfig';
import { pendo } from '../../../util/logging';
import style from './FakeDoorButton.module.scss';

const FakeDoorButton = ({ narrow }) => {
  const fakeDoorConfig = useRemoteConfig('fake_door_config');

  if (!fakeDoorConfig?.show) {
    return null;
  }

  const { text, iconInactive, iconActive, showNew } = fakeDoorConfig;

  const handleClick = () => {
    pendo.track('fake_door_button_click', {
      buttonText: text,
      showNewBadge: showNew,
      iframeUrl: fakeDoorConfig.iframeUrl,
    });
  };

  return (
    <NavLink
      to="/receivables/customer-landing-page"
      className={style.link}
      data-testid="navigation-fakedoor"
      data-trackingid="navigation-fakedoor"
      id="navigation-fakedoor-link"
      aria-label={text}
      onClick={handleClick}
    >
      <Shelf py={12}>
        <div
          className={style.fakeDoorIcon}
          style={{
            '--icon-inactive': `url('${iconInactive}')`,
            '--icon-active': `url('${iconActive}')`,
          }}
          aria-hidden="true"
        />
        {!narrow && (
          <Text fontWeight="inherit" fontSize="medium" color="inherit">
            <div>
              {text}
              {showNew && (
                <>
                  {' '}
                  <span
                    style={{
                      backgroundColor: 'rgb(238, 115, 76)',
                      fontSize: '12px',
                      color: '#ffffff',
                      fontWeight: 'bold',
                      padding: '2px 4px',
                      borderRadius: '4px',
                    }}
                  >
                    NEW
                  </span>
                </>
              )}
            </div>
          </Text>
        )}
      </Shelf>
    </NavLink>
  );
};

export default FakeDoorButton;
